import { useQuery } from '@tanstack/react-query'
import { getCourseDetail, getCourseDetailLoggedIn } from '../../../api/courses'
import { useAuth } from '../../../provider/AuthProvider'

interface UseContentDetailParams {
  id: string
  type?: string
  isAdmin?: boolean
}

export const useContentDetail = ({
  id,
  type,
  isAdmin = false,
}: UseContentDetailParams) => {
  const { role, isAuthenticated } = useAuth()
  const resolvedIsAdmin = isAdmin || role === 'admin'
  // type bisa digunakan untuk queryKey, jika API butuh, bisa di-extend
  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ['contentDetail', id, type, resolvedIsAdmin, isAuthenticated],
    queryFn: () =>
      isAuthenticated
        ? getCourseDetailLoggedIn(id)
        : getCourseDetail(id, resolvedIsAdmin),
    enabled: !!id,
  })

  return {
    course: data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  }
}
